import { Loadable } from 'utils/components';
import { SCREENS_PATH as path } from 'constants/paths';

export default {
  path,
  component: Loadable({
    loader: () => import(/* webpackChunkName: 'Screens' */ './components/ScreensPage')
  })
};
